var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5567 3.5105L36.7422 3.5L36.9697 3.514L37.1272 3.542L37.3425 3.60325L37.5297 3.68375L37.7047 3.7835L37.8622 3.90075L38.0057 4.032L38.0967 4.13525L38.2402 4.33825L38.3312 4.50625C38.4129 4.68125 38.4654 4.86558 38.4887 5.05925L38.4975 5.24475C38.4975 5.37658 38.4835 5.50492 38.4555 5.62975L38.3942 5.845L26.9632 37.4797C26.7466 37.9515 26.399 38.3511 25.962 38.6312C25.5249 38.9114 25.0166 39.0602 24.4975 39.06C24.03 39.061 23.5703 38.9411 23.1628 38.7121C22.7553 38.483 22.4139 38.1526 22.1717 37.7527L22.058 37.5305L16.192 25.802L4.5195 19.964C4.0876 19.7665 3.71514 19.459 3.43935 19.0724C3.16357 18.6857 2.99414 18.2334 2.948 17.7608L2.9375 17.5C2.9375 16.52 3.46425 15.624 4.40925 15.1025L4.65425 14.98L36.184 3.5945L36.3695 3.542L36.5567 3.5105Z",
    fill: "#27BAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.5c199bd193b9baa3baeba24eb449c9e2.svg";
export { ForwardRef as ReactComponent };